module.exports = __webpack_public_path__ + "static/media/ShivasGuard.c2a7bbc1.png";